import React from 'react'
import './About.css'
import developer_img from '../../assets/developer_img.png'

function About(){
    return(

        <div className="row4">
        <div className="col-md">
          <h1>About <strong class="purple-about">ME</strong></h1>

          <div className="quote-card-view card">
            <div className="card-body">

              <blockquote className="blockquote mb-0">
                <p className='justify'>
                  Hi everyone, I am
                  <span className='purple-about'>Anish Kumar</span>
                  from 
                  <span className='purple-about'>Bokaro Steel City, India.</span>
                  <br/>
                  I am a passionate and data driven React developer with experience building scalable Websites and Web Apps & App developer with experience in building mobile applications for Android & iOS.
                  <br/>
                  <br/>
                  I enjoy connecting the dots: be it ideas from different disciplines, people from different teams, or applications from different industries.
                  <br/>
                  I am skiled in building dynamic websites and robust mobile applications with a focus on delivering seamless user experiences. Passionate about leveraging cutting-edge technologies to drive innovation and create user-centric solutions.
                  <br/>
                  <br/>
                </p>

                <p className='error_quote'>"The best error message is the one that never shows up." </p>

                <footer className="blockquote-footer">
                  - Thomas Fuchs
                </footer>
              </blockquote>


            </div>
           </div>
        </div>
        
        <div className="about-img col-md-5">
          <img src={developer_img} alt="about" className="img-fluid" />
        </div>    
        
        </div>   
     


            
        
             
        
        
    );
}

export default About;